import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_GET_VISUALISER_DOCUMENT_UTILISATEUR } from '../../constants/apiUrls.constants';

const documentUtilisateur = combineReducers({
    recupererDocumentUtilisateur: APIReducer.bind(
        null,
        CONTEXT_GET_VISUALISER_DOCUMENT_UTILISATEUR,
    ),
});

export default documentUtilisateur;
